// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog-module--blog--2xJf4","blogTitle":"blog-module--blogTitle--1DrvM","blogList":"blog-module--blogList--2LSpW","link":"blog-module--link--3BM0V"};